<div *ngIf="itemType" class="container-fluid">
  <div mat-dialog-title>
    <div *ngIf="itemType.itemType_ID" i18n>Edit Item Type</div>
    <div *ngIf="!itemType.itemType_ID" i18n>Add Item Type</div>
  </div>
  <div class="row">
    <div *ngIf="itemType.itemType_ID" class="col-sm-8" i18n>Make the necessary changes on the form below then click Submit</div>
    <div *ngIf="!itemType.itemType_ID" class="col-sm-8" i18n>To add a new Item Type, complete the form below then click Submit.</div>
    <div class="float-right warning col-sm-4" i18n>* Required Information</div>
  </div>
  <mat-dialog-content class="pt-3">
    <form #form="ngForm" (ngSubmit)="saveItemType(form)">
      <div class="form-group row">
        <div class="col-md-12 form-inline">
          <div class="control-wrapper">
            <label class="col-sm-4" for="itemTypeDesc"><span class="warning">* </span><span i18n>Item Type</span></label>
            <input id="itemTypeName" name="itemTypeName" class="form-control col-sm-8" [(ngModel)]="itemType.itemType_Desc"
                   required #itemTypeName="ngModel"
                   [class.field-error]="form.submitted && itemTypeName.invalid">
            <div [hidden]="!form.submitted || itemTypeName.valid"
                 class="alert alert-danger" i18n>Item Type is required</div>
          </div>
        </div>
      </div>
      <div *ngIf="this.isIDIAdmin && this.dealerId == null" class="form-group row">
        <label class="col-sm-4" for="itemCoverageTypes" i18n>Item Coverage Type</label>
        <select name="itemCoverageTypes" id="itemCoverageTypes" class="form-control col-sm-8 select-bidit" [(ngModel)]="itemType.itemCoverageType_ID">
          <option [ngValue]="null" selected="">-</option>
          <option [ngValue]="coverageTypes.Blow">{{getItemCoverageTypeName(coverageTypes.Blow)}}</option>
          <option [ngValue]="coverageTypes.Inches">{{getItemCoverageTypeName(coverageTypes.Inches)}}</option>
          <option [ngValue]="coverageTypes.AeroBarrier">{{getItemCoverageTypeName(coverageTypes.AeroBarrier)}}</option>
        </select>
      </div>
      <div *ngIf="(!this.isIDIAdmin || (this.isIDIAdmin && this.dealerId != null)) && this.itemType.itemCoverageType_ID != coverageTypes.AeroBarrier" class="form-group row">
        <label class="col-sm-4" for="itemCoverageTypes" i18n>Item Coverage Type</label>
        <select name="itemCoverageTypes" id="itemCoverageTypes" class="form-control col-sm-8 select-bidit" [(ngModel)]="itemType.itemCoverageType_ID">
          <option [ngValue]="null" selected="">-</option>
          <option [ngValue]="coverageTypes.Blow">{{getItemCoverageTypeName(coverageTypes.Blow)}}</option>
          <option [ngValue]="coverageTypes.Inches">{{getItemCoverageTypeName(coverageTypes.Inches)}}</option>
        </select>
      </div>
      <div *ngIf="(!this.isIDIAdmin || (this.isIDIAdmin && this.dealerId != null)) && this.itemType.itemCoverageType_ID == coverageTypes.AeroBarrier" class="form-group row">
        <label class="col-sm-4" for="itemCoverageTypes" i18n>Item Coverage Type</label>
        <select [disabled]="true" name="itemCoverageTypes" id="itemCoverageTypes" class="form-control col-sm-8 select-bidit" [(ngModel)]="itemType.itemCoverageType_ID">
          <option [ngValue]="null" selected="">-</option>
          <option [ngValue]="coverageTypes.Blow">{{getItemCoverageTypeName(coverageTypes.Blow)}}</option>
          <option [ngValue]="coverageTypes.Inches">{{getItemCoverageTypeName(coverageTypes.Inches)}}</option>
          <option [ngValue]="coverageTypes.AeroBarrier">{{getItemCoverageTypeName(coverageTypes.AeroBarrier)}}</option>
        </select>
      </div>
      <div class="form-group row">
        <label class="col-sm-4" for="itemType_IsAccessory" i18n>Is Accessory?</label>
        <div class="col-sm-8">
          <mat-radio-group name="isAccessory" id="isAccessory"
                           [(ngModel)]="itemType.itemType_IsAccessory"
                           required #isAccessory="ngModel">
            <mat-radio-button class="mr-3" [value]="true" i18n>Yes</mat-radio-button>
            <mat-radio-button [value]="false" i18n>No</mat-radio-button>
          </mat-radio-group>
          <div [hidden]="!form.submitted || isAccessory.valid"
               class="alert alert-danger" i18n>Is Accessory is invalid</div>
        </div>
      </div>

      <!--<div class="form-group row">
        <label class="col-sm-4" for="itemType_Preinstructions" i18n>Pre-Installation Instructions</label>
        <quill-editor theme="snow" [(ngModel)]="itemType.itemType_Preinstructions" name="itemType_Preinstructions" id="itemType_Preinstructions" class="col-sm-8"></quill-editor>
      </div>

      <div class="form-group row">
        <label class="col-sm-4" for="itemType_Postinstructions" i18n>Post-Installation Instructions</label>
        <quill-editor [(ngModel)]="itemType.itemType_Postinstructions" name="itemType_Postinstructions" id="itemType_Postinstructions" class="col-sm-8"></quill-editor>
      </div>-->
      <mat-dialog-actions align="end">
        <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
        <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
      </mat-dialog-actions>
      <app-spinner [isRunning]="isRequesting"></app-spinner>

      <div class="mt-3">
        <div [hidden]="!form.submitted || form.valid"
             class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
      </div>
    </form>
  </mat-dialog-content>
</div>
